import { ArsContextState } from "../interface";

/**
 * Marks ARS changes as sent.
 *
 * @param state - Current ARS context state
 * @returns Updated state with changed flag reset
 */
export const arsc_changeSent = <T>(state: ArsContextState<T>): ArsContextState<T> => ({
  ...state,
  changed: false,
});
